import { IMplServiceClient } from './IMplServiceClient';
import MplServiceClient from './MplServiceClient';
import { MplServiceClientV2 } from './MplServiceClientV2';
import MplServiceClientMock from './MplServiceClientMock';

export class MplServiceClientFactory {
  /**
   * @deprecated Use the `useMplServiceClient` hook from `src/contexts/MplServiceClientContext` instead.
   */
  public static create(): IMplServiceClient {
    if (!MplServiceClientFactory.instance) {
      MplServiceClientFactory.instance = new MplServiceClient();
    }

    return MplServiceClientFactory.instance;
  }

  /** Returns the shared v2 client that throws typed `ServiceCallError` and has no Flashbar coupling. */
  public static createV2(): IMplServiceClient {
    if (!MplServiceClientFactory.v2Instance) {
      MplServiceClientFactory.v2Instance = new MplServiceClientV2();
    }

    return MplServiceClientFactory.v2Instance;
  }

  private static instance: IMplServiceClient;
  private static v2Instance: IMplServiceClient;
}
